import * as React from "react"
import { cn } from "@/lib/utils"

/** The default section container header — replaces Card+CardHeader (rule 2). */
function SectionRule({ label, action, className, ...props }) {
  return (
    <div
      className={cn("mb-4 flex items-baseline justify-between border-t border-line pt-3", className)}
      {...props}>
      <h2 className="text-micro uppercase text-ink-subtle">{label}</h2>
      {action}
    </div>
  )
}

export { SectionRule }
